@if (showTrialExpiredModal()) {
    <app-trial-expired-modal />
}
<div class="flex w-full flex-1 overflow-y-hidden">
    <app-sidebar class="relative flex" />
    <main
        class="relative flex h-full w-full flex-col overflow-auto bg-twMainBackground text-twTextPrimary [scrollbar-gutter:stable]">
        <!-- z-50 so the topbar (and its avatar/bell dropdowns) sit above any in-page
             sticky chrome — e.g. the agent editor's sticky header (z-30) and footer (z-40).
             When the trial-expired modal (z-[100]) is up it would otherwise bury the topbar,
             leaving the user with no way to log out / switch account. <main> and the flex
             wrapper don't form stacking contexts, so the topbar's z-index resolves at the
             root and a value > 100 lifts it (and its user menu) above the modal backdrop.
             Kept conditional so normal drawers/modals still cover the topbar as usual. -->
        <app-topbar
            class="sticky top-0 z-50"
            [style.z-index]="showTrialExpiredModal() ? 120 : null" />
        <!-- -mt-px tucks the page (and its submenu) 1px under the sticky topbar so the
             sub-pixel seam between the translucent topbar and the content can't bleed
             through as a 1px gap above the submenu. -->
        <div class="-mt-px flex min-h-0 flex-1 flex-col">
            <router-outlet />
        </div>
    </main>
</div>

<!-- Global Agent Chat: slide-in panel + settings modal. The launcher lives in the topbar. -->
<app-agent-chat-panel />
<app-agent-chat-settings />

<!-- Voice shell (app-wide, not inbox-only): the ring card for an incoming call, the
     floating "calls waiting" queue and the live-call bar follow the agent on every route. -->
<app-voice-incoming-call />
<app-voice-queue-widget />
<app-voice-call-bar />
